module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2x5eU"))).then(() => parcelRequire('hEqeo'));